import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { environment } from '../../environments/environment';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { ClipboardModule } from '@angular/cdk/clipboard'; // <--- AGGIUNGI QUESTO
import { MatTooltipModule } from '@angular/material/tooltip'; // Opzionale, per il feedback
import { StrutturaDettaglioDialogComponent } from '../struttura-dettaglio-dialog/struttura-dettaglio-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CalendarioOperatoreComponent } from '../calendario-operatore/calendario-operatore.component';

@Component({
  selector: 'app-operatore-dettaglio',
  standalone: true,
  imports: [
    CommonModule, RouterModule, HttpClientModule,
    MatCardModule, MatButtonModule, MatIconModule, MatChipsModule, MatDividerModule,
    HeaderComponent, FooterComponent, ClipboardModule, MatTooltipModule
  ],
  templateUrl: './operatore-dettaglio.component.html',
  styleUrl: './operatore-dettaglio.component.css'
})
export class OperatoreDettaglioComponent implements OnInit {
  private readonly API_BASE = environment.API_ENDPOINT_COT_SERVICE;
  operatore: any = null;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.caricaDettaglio(id);
    }
  }

  caricaDettaglio(id: string) {
    this.http.get(`${this.API_BASE}/operatori/${id}`).subscribe({
      next: (res) => {
        this.operatore = res;
        this.loading = false;
      },
      error: (err) => {
        console.error("Errore nel caricamento del dettaglio", err);
        this.loading = false;
      }
    });
  }

  goBack() {
    this.router.navigate(['/anagrafiche-professionisti']);
  }

  openStrutturaDetail(struttura: any) {
    this.dialog.open(StrutturaDettaglioDialogComponent, {
      width: '500px',
      data: struttura,
      autoFocus: false
    });
  }

  openCalendario(ruoloId: number) {
    this.dialog.open(CalendarioOperatoreComponent, {
      width: '95vw',      // Quasi tutta la larghezza per far stare bene il calendario
      maxWidth: '1600px',
      height: '90vh',
      panelClass: 'custom-dialog-container', // Classe opzionale per gestire i margini
      data: {
        operatoreId: this.operatore.id, // Preso dall'URL tramite ActivatedRoute
        qualificaId: ruoloId
      }
    });
    console.log(this.operatore.id)
    console.log(ruoloId)
  }
}